import { Component } from '@angular/core';
import { NavController, NavParams, IonicPage } from 'ionic-angular';
import { version } from '../../app/app.constants';


@IonicPage()
@Component({
  selector: 'page-configuration-admin',
  templateUrl: 'configuration-admin.html',
})
export class ConfigurationAdminPage {

  version = version;
  
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
  ) {}
}



// WEBPACK FOOTER //
// ./src/pages/configuration-admin/configuration-admin.ts